export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 px-4 md:px-6 bg-background-100 scroll-mt-20">
      <div className="max-w-[1280px] mx-auto">
        <div className="max-w-2xl mx-auto text-center">
          <div className="w-16 h-16 rounded-2xl bg-primary-100 flex items-center justify-center mx-auto mb-6">
            <i className="ri-mail-send-line text-primary-500 text-2xl"></i>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            投稿爆料
          </h2>
          <p className="text-foreground-500 text-sm md:text-base mb-8 max-w-md mx-auto">
            有猛料？有独家？欢迎投稿！你的爆料可能成为下一个热门话题。
            编辑团队每日审核，优质投稿优先发布。
          </p>

          <div className="bg-background-50 rounded-2xl border border-background-200/60 p-6 md:p-8">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
              <div className="text-center p-4">
                <div className="w-10 h-10 rounded-xl bg-primary-100 flex items-center justify-center mx-auto mb-2">
                  <i className="ri-mail-line text-primary-500 text-lg"></i>
                </div>
                <p className="text-xs text-foreground-500">投稿邮箱</p>
                <p className="text-sm font-semibold text-foreground-800">tougao@onlinechigua.com</p>
              </div>
              <div className="text-center p-4">
                <div className="w-10 h-10 rounded-xl bg-accent-100 flex items-center justify-center mx-auto mb-2">
                  <i className="ri-wechat-line text-accent-500 text-lg"></i>
                </div>
                <p className="text-xs text-foreground-500">微信公众号</p>
                <p className="text-sm font-semibold text-foreground-800">在线吃瓜</p>
              </div>
              <div className="text-center p-4">
                <div className="w-10 h-10 rounded-xl bg-secondary-100 flex items-center justify-center mx-auto mb-2">
                  <i className="ri-message-3-line text-secondary-500 text-lg"></i>
                </div>
                <p className="text-xs text-foreground-500">响应时间</p>
                <p className="text-sm font-semibold text-foreground-800">24小时内</p>
              </div>
            </div>

            <p className="text-xs text-foreground-400">
              投稿内容须真实合法，不得侵犯他人权益。本平台保留审核和发布权利。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}